const drupalJsonApiResourceTypeToBundle = function (type) {
    return type.split('--')[1]
}

module.exports = {
    drupalJsonApiResourceTypeToBundle
};
